import { Id } from "PFTypes";
import { LocalisationKeys } from "PFTypes";

const ROOT_KEY = "saas_admin";

export const queryKeys = {
  all: (accountId: number) => [ROOT_KEY, "localisation", accountId],
  localisation: (accountId: number, key: LocalisationKeys) => [...queryKeys.all(accountId), key],
  localisationPage: (accountId: number, key: LocalisationKeys, page?: number) => [
    ...queryKeys.localisation(accountId, key),
    page
  ],
  localisationEntry: (accountId: number, key: LocalisationKeys, entryId: Id) => [
    ...queryKeys.localisation(accountId, key),
    entryId
  ],
  localisationImport: (accountId, id) => [ROOT_KEY, "localisation_import", accountId, id],
  localisationExport: (accountId, key, locales) => [
    ROOT_KEY,
    "localisation_export",
    accountId,
    key,
    ...locales
  ]
};
